import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./components/authentication/login";
import Signup from "./components/authentication/signup";
import Sidebar from "./components/sideNavBar";
import Home from "./components/home/home";
import Posts from "./components/posts/posts.js"
import Chats from "./components/chats/chats.js"
import Profile from "./components/profile/profile.js"
import ItemSection from "./components/home/item_section.js";
import ViewItem from "./components/home/view_item.js";
import ViewCast from "./components/home/view_cast.js";
import ViewDiscussions from "./components/home/view_discussions.js";
import Search from "./components/search/search.js";
import ViewProfile from "./components/search/view_profile.js";
import EditProfile from "./components/profile/edit_profile.js";
import Collection from "./components/collections/collection.js";
import CollectionDetails from "./components/collections/collection_details.js";
import ViewCollection from "./components/search/view_collection.js";
import PageNotFound from "./components/unknown/page_not_found.js";
import ErrorClass from "./components/unknown/error_class.js";
import Support from "./components/support/support.js";
import SupportUs from "./components/support/support_us.js";
import ContactUs from "./components/support/contact_us.js";
import AboutUs from "./components/support/about_us.js";
import VoteScreen from "./components/vote/vote.js";
import VoteSection from "./components/vote/vote_section.js";
import Conversations from "./components/chats/conversations.js";
import ViewTopVotes from "./components/home/view_top_votes.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SearchProvider } from "./components/chats/searchContext.js";

const App = () => {
  return (
    <SearchProvider>
      <BrowserRouter>
        <ErrorClass>
          <Routes>
            <Route path="/" element={<Login/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/signup" element={<Signup/>} />
            <Route path="/main_back/*" element={
              <div className="d-flex" style={{ backgroundColor:'#03132a' }}>
                <Sidebar />
                <div id="page-content-wrapper" className="flex-grow-1">
                  <Routes>
                    <Route path="home" element={<Home />} />
                    <Route path="home/top-votes" element={<ViewTopVotes />} />
                    <Route path="home/:genre-movies-and-series/:id" element={<ItemSection />} />
                    <Route path="home/:genre/:form/:id" element={<ViewItem />} />
                    <Route path="home/:type/cast/:name/:id" element={<ViewCast />} />
                    <Route path="home/:type/discussions/:name/:id" element={<ViewDiscussions />} />
                    <Route path="posts" element={<Posts />} />
                    <Route path="chats" element={<Chats />} />
                    <Route path="chats/:username" element={<Conversations />} />
                    <Route path="collections" element={<Collection />} />
                    <Route path="collections/:id/:name" element={<CollectionDetails />} />
                    <Route path="search" element={<Search />} />
                    <Route path="search/:username/profile" element={<ViewProfile />} />
                    <Route path="search/:username/collections/:id/:name" element={<ViewCollection />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="profile/edit" element={<EditProfile />} />
                    <Route path="support" element={<Support />} />
                    <Route path="support/about_us" element={<AboutUs />} />
                    <Route path="support/contact_us" element={<ContactUs />} />
                    <Route path="support/support_us" element={<SupportUs />} />
                    <Route path="vote" element={<VoteScreen />} />
                    <Route path="vote/:genre/:type" element={<VoteSection />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </div>
              </div>
            }/>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </ErrorClass>
      </BrowserRouter>
    </SearchProvider>
  );
};

export default App;
